/** Test switch: when set, nothing in the app makes a sound (used for automated QA). */
export const isSilent = () => !!(globalThis as unknown as { __ahillahSilent?: boolean }).__ahillahSilent;
